<belender-widget-step-logo [data]="data" [customImage]="logoCustom"></belender-widget-step-logo>

<form [formGroup]="form" class="animated fadeIn fixed-content px-2">
  <div class="py-1 flex flex-col">
    <div
      id="otpTitle"
      *ngIf="texts && texts[otpType]?.title && texts[otpType]?.title != ''"
      [style.color]="data.styles?.colors.title"
      [style.font-size]="texts.form.titleSize + 'px'"
      class="title m-0"
      [innerHTML]="texts[otpType].title"
    ></div>
    <div
      id="otpDescription"
      *ngIf="
        texts &&
        texts[otpType]?.description &&
        texts[otpType]?.description != ''
      "
      [style.color]="data.styles?.colors.text"
      class="subheading-1 pt-4"
      [innerHTML]="texts[otpType]?.description | safeHtml"
    ></div>

    <div class="title py-2">
      <ng-container *ngIf="secsCount && secsCount > 0">
        <small
          id="secsCountContainer"
          class="info-time w-full"
          [ngStyle]="{
            color: data.styles?.colors.accentColor,
            border: '1px solid ' + data.styles?.colors.accentColor,
            background: data.styles?.colors.accentBgColor
          }"
        >
          <!-- secsCount texts -->
          <ng-container *ngIf="!lastThreeNumbersPhone">
            {{labels ? labels.otp.requestingOtp : 'Estamos solicitando el código. Por favor, espere un momento.'}}
          </ng-container>
          <ng-container
            *ngIf="lastThreeNumbersPhone && !data.config?.noRetryInBadPhone"
          >
            {{labels ? labels.otp.otpSentToNumber : 'El código ha sido enviado al teléfono acabado en'}}
            {{ lastThreeNumbersPhone }}.
          </ng-container>
          <ng-container
            *ngIf="lastThreeNumbersPhone && data.config?.noRetryInBadPhone"
          >
            {{labels ? labels.otp.requestingCode : 'Estamos solicitando el código. Por favor, espere un momento.'}}
          </ng-container>
        </small>
      </ng-container>

      <ng-container *ngIf="!secsCount || secsCount <= 0">
        <small
          class="info-time w-full"
          [ngStyle]="{
            color: data.styles?.colors.dangerColor,
            border: '1px solid ' + data.styles?.colors.dangerColor,
            background: data.styles?.colors.dangerBgColor
          }"
        >
          <span *ngIf="!lastThreeNumbersPhone">
            {{labels ? labels.otp.noReceivedCode : '¿No has recibido el código en tu teléfono?'}}
          </span>
          <span *ngIf="lastThreeNumbersPhone && !data.config?.noRetryInBadPhone"
            >{{labels ? labels.otp.noReceivedCode2 : '¿No has recibido el código en el teléfono acabado en'}}
            {{ lastThreeNumbersPhone }}?
          </span>
          <span *ngIf="data.config?.noRetryInBadPhone">
            {{labels ? labels.otp.noReceivedCode : '¿No has recibido el código en tu teléfono?'}}
          </span>
          <a
            id="resendOTPButton"
            *ngIf="!secondTry"
            class="ml-4"
            [ngStyle]="{
              color: data.styles?.colors.dangerTextButtonColor,
              background: data.styles?.colors.dangerColor
            }"
            (click)="resendOTP()"
          >
            {{labels ? labels.actions.resend : 'Reenviar'}}
          </a>
        </small>
      </ng-container>
    </div>

    <div class="flex w-full flex-col gap-2 py-2">
      <p
        [style.color]="data.styles.colors.text"
        class="subheading-1 py-1 custom-html"
      >
        {{labels ? labels.otp.otpCode : 'Código OTP (recibido por SMS)'}}
      </p>
      <ng-otp-input
        #ngOtpInput
        (onInputChange)="capturePasteEvent($event)"
        [config]="{
          length: minLength,
          allowNumbersOnly: env != 'qa' && env != 'dev'
        }"
      ></ng-otp-input>
    </div>
  </div>


  <div class="flex items-center gap-2 py-4 flex-col md:flex-row" [ngClass]="{'justify-start': data.styles.alignButtons === 'left', 'justify-center': data.styles.alignButtons === 'center', 'justify-end': data.styles.alignButtons === 'right' || !data.styles.alignButtons}">
    <button
      [style.color]="data.styles?.colors.btnText"
      [style.background]="form.invalid ? '' : data.styles?.colors.btnBg"
      [style.border-radius]="data.styles?.btnRound + 'px'"
      [disabled]="form.invalid"
      (click)="nextStep()"
      id="next-button"
      class="px-8 w-full max-w-none md:max-w-[220px]"
      mat-flat-button
      type="button"
    >
      {{labels ? labels.actions.next : 'Siguiente'}}
    </button>
  </div>
</form>
